import type { TransformerExtended } from "@/Common/Models/Domain/Transformer";

import type { InfoApi } from "@/Modules/Patients/Models/Api";
import type { InfoFilter } from "@/Modules/Patients/Models/Domain";

import { camel } from "@/Utils/Camelize";
import DefaultTransformerGenerator from "@/Common/Transformers/FunctionalBase";

const InfoFilterTransformer: TransformerExtended<InfoFilter, InfoApi> = {
  ...DefaultTransformerGenerator<InfoFilter, InfoApi>(),

  toDomain(input: InfoApi) {
    return camel<InfoApi, InfoFilter>(input);
  },
};

export type PlanTransformerType = TransformerExtended<InfoFilter, InfoApi>;

export default InfoFilterTransformer;
